import React from "react";
import "./MaintenancePage.scss";
import { Container } from "react-bootstrap";

const MaintenancePage = () => {
  return (
    <section className="maintenance-page">
      <Container>
        <div className="maintenance-container">
          <div className="maintenance-image">
            <img
              src="/images/froi-maintance.png"
              alt="Website under maintenance"
            />
          </div>

          <div className="maintenance-content">
            <h1>We’ll Be Back Soon</h1>

            <p className="maintenance-description">
              FROI’s website is currently undergoing scheduled enhancements to
              integrate our latest research, strategic frameworks, and global
              insights.
            </p>

            <p className="maintenance-date">
              We return on <strong>October 10, 2026</strong>
            </p>

            <p className="maintenance-contact">
              For inquiries:{" "}
              <a href="mailto:info@froiglobal.org">info@froiglobal.org</a>
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default MaintenancePage;
